module.exports = __webpack_public_path__ + "img/lifelinemed123-logo.0a9bf322.png";